import React from 'react';
import Loader from '@/components/common/Loader';
import useBulkImports from '@/lib/hooks/swr/useBulkImports';
import translate from '@/lib/intl/translate';
import BulkImportStatus from '../../config/BulkImportStatus';
import type BulkImport from '../../types/BulkImport';
// eslint-disable-next-line import/no-cycle -- TODO: Fix this the next time the file is edited.
import DataUploadsTable from './DataUploadsTable';
import NewDataUploadButton from './NewDataUploadButton';

export function isUploadProcessing(data?: BulkImport[]) {
  const activeBulkImportStatus = [
    BulkImportStatus.NEW,
    BulkImportStatus.HEADERS_MAPPED,
    BulkImportStatus.PRE_PROCESSING_DATA,
    BulkImportStatus.DATA_PRE_PROCESSED,
    BulkImportStatus.READY_TO_PROCESS,
    BulkImportStatus.PROCESSING_DATA,
  ];
  return data
    ? data?.some((row) => activeBulkImportStatus.includes(row.status))
    : true;
}

export default function DataUploadsPage() {
  const { data } = useBulkImports();

  const NewUploadButton = (
    <NewDataUploadButton disabled={isUploadProcessing(data)} />
  );

  return (
    <div className="min-w-full p-4">
      <div className="mb-4 flex items-center justify-between">
        <h2 className="type-h2">{translate('DATA_UPLOADS')}</h2>
        {NewUploadButton}
      </div>
      {!data && <Loader isCentered />}
      {data && !!data?.length && <DataUploadsTable data={data} />}
      {data && !data?.length && (
        <div className="flex w-full flex-col items-center gap-2 pt-10">
          <div className="type-body2">
            {translate('DATA_UPLOADS_NO_DATA_UPLOADS')}
          </div>
          <div className="text-text-secondary type-body1">
            {translate('DATA_UPLOADS_IMPORT_YOUR_ORGS_DATA')}
          </div>
          {NewUploadButton}
        </div>
      )}
    </div>
  );
}
